import { cn } from "@/lib/cn";

type OrnamentProps = {
  className?: string;
  label?: string;
};

/**
 * Hand-drawn 8-point rosette divider. Used to separate sections with a
 * culturally grounded note that's neither a generic horizontal rule nor a
 * literal religious icon.
 */
export function Ornament({ className, label }: OrnamentProps) {
  return (
    <div
      role="presentation"
      className={cn("flex items-center justify-center gap-4 text-accent", className)}
    >
      <span className="h-px flex-1 max-w-[120px] bg-gradient-to-r from-transparent to-accent/40" />
      <svg
        viewBox="0 0 48 48"
        className="h-5 w-5 ornament"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.25"
        aria-hidden="true"
      >
        <g transform="translate(24 24)">
          {Array.from({ length: 8 }).map((_, i) => (
            <line
              key={i}
              x1="0"
              y1="-18"
              x2="0"
              y2="-6"
              transform={`rotate(${i * 45})`}
              strokeLinecap="round"
            />
          ))}
          <polygon points="0,-10 10,0 0,10 -10,0" />
          <polygon points="0,-10 10,0 0,10 -10,0" transform="rotate(45)" />
          <circle r="2.4" fill="currentColor" stroke="none" />
        </g>
      </svg>
      {label ? (
        <span className="eyebrow whitespace-nowrap text-accent">{label}</span>
      ) : null}
      <span className="h-px flex-1 max-w-[120px] bg-gradient-to-l from-transparent to-accent/40" />
    </div>
  );
}
